import React from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import "../assets/style.scss"

type propType = {
  configValue: string
}

const LandingHeader = ({ configValue }: propType) => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Block className="landing-header-text" dangerouslySetInnerHTML={{ __html: configValue }}>
        </Block>
      </Block>
      <Image path={"./img/ticari-kredi-karti-lead/ticari-kredi-karti-lead-header.jpg"} className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
